import {Modal, View} from "react-native";
import React from "react";
import {LinearGradient} from "expo-linear-gradient";

import {styles} from "./styles";

export const BaseModal = ({visible, onPressClose, children}) => {
    return (
        <Modal
            animationType="slide"
            presentationStyle="overFullScreen"
            statusBarTranslucent={true}
            transparent={true}
            visible={visible}
            onRequestClose={() => {
                onPressClose();
            }}
        >
            <View style={styles.centeredView}>
                <LinearGradient
                    style={styles.baseModal.gradientView}
                    colors={["rgba(52, 127, 180, 0.4)", "rgba(34, 147, 172, 0.4)", "rgba(43, 113, 176, 0.4)"]}
                    locations={[0, 0.6, 1]}
                    start={{x: 0.6, y: 0}}
                    end={{x: 0.4, y: 1}}
                >
                    <View style={styles.baseModal.contentView}>
                        {children}
                    </View>
                </LinearGradient>
            </View>
        </Modal>
    )
}
